export default "__VITE_ASSET__DSBHBJOJ__"